import * as React from "react";
import { Component } from "react";
import styles from "../../styles/wizards/superadmin/AddProductCategoryWizard.scss";
import autobind from "autobind-decorator";
import AddProductCategoryIcon from "../../assets/images/add-functional-space-64x64.svg";
import { mapStateToProps, setTableParams, validateForm } from "../../core/utils";
import { withRouter } from "react-router";
import { setNotification } from "../../redux/actions/general/notification";
import { createProductCategory, listProductCategories } from "../../redux/actions/table/superadmin/product_categories";
import AddProductCategoryForm from "../../forms/superadmin/add_product_categories_wizard/AddProductCategoryForm";

@withRouter
@mapStateToProps(state => ({
	table: state.table["superadmin_product_categories"],
}))
class AddProductCategoryWizard extends Component {
	@autobind
	_handleSubmit(formData) {
		const { edit } = formData;

		return validateForm(
			createProductCategory(formData).then(({ response }) => {
				listProductCategories().then(() => {
					if (edit) {
						setTableParams('superadmin_product_categories', {
							clicked_row: response.data.id
						});
					}
				});

				setTableParams('superadmin_product_categories', {
					actioned_row: undefined,
					selected_rows: []
				});

				this.props.onClose();

				setNotification("You have successfully added a new product category.");
			})
		);
	}

	render() {
		return (
			<>
				<div className={styles.header}>
					<div className={styles.left}>
						<span>Add product category</span>
						<span>Add product category to system product categories</span>
					</div>
					<div className={styles.right}>
						<AddProductCategoryIcon />
					</div>
				</div>
				<div className={styles.body}>
					<AddProductCategoryForm onSubmit={this._handleSubmit} initialValues={{
						name: {},
					}} />
				</div>
			</>
		);
	}
}

export default AddProductCategoryWizard;